import {getBusinesMenuCategoriesFilter, getMarketplaceFilter, sortByProp, sortByPropNumber} from '../filter';
import { createControlModel } from '../controlModelFactory';
import FilterOptionsModel from './../../models/filterOptionsModel';
import SectionModel from '../../models/sectionModel';

import {
  CANCEL_REASON, CANCEL_REASON_GET,
  GREETING_TEMPLATE, GREETING_TEMPLATE_GET, GREETING_TEMPLATE_TOGGLE_ENABLED, GREETING_TEMPLATE_UPDATE,
  MARKETPLACE_MESSAGE,
  MARKETPLACE_MESSAGE_TOGGLE_ENABLED,
  MARKETPLACE_MESSAGE_UPDATE,
  MARKETPLACE_SETTINGS, SCHEDULE_SETTINGS, SCHEDULE_SETTINGS_GET,
  SHIPMENT_PRICE_CONFIGURATION,
  SHIPMENT_PRICE_CONFIGURATION_GET,
} from '../../store/reducers/restaurant/restaurant-actions';
import { MARKETPLACE_MESSAGE_GET } from '../../store/reducers/order/order-actions';

import {
  CONTROL_TYPE,
  getMarketplaceMessageTypes,
  getMerchantDeliveryCostCalculationModeItems,
  MARKETPLACE_SETTINGS_MODEL,
  MODEL_CONTROL_TYPE, MODEL_TYPE, TYPE_ACTION,
  SupportChatType,
  supportChatTypeValues,
  TYPE_SECTION_MESSAGE_MODEL,
} from '../../utils/enums';
import {isMobileWidth} from '../restaurant';
import {getInitModel} from '../initModels';
import { createBreadcrumbModel } from '../createBreadcrumbModel';
import i18n from 'i18next';

export function createMarketplaceSectionModel() {
  return new SectionModel({
    filterOptions: createServiceCitiesSectionFilter(),
    columns: [
      {
        title: 'settings.marketplaceMessage.LABEL',
        component: item => item.label || item.title,
      },
      {
        title: 'settings.marketplaceMessage.LANGUAGE',
        accessor: 'language',
        type: CONTROL_TYPE.text,
      },
      {
        title: 'settings.marketplaceMessage.TYPE',
        accessor: 'type_enum',
        type: CONTROL_TYPE.text,
      },
      {
        title: 'basic.EDIT_BUTTON',
        width: '90px',
        centered: true,
        type: CONTROL_TYPE.link,
        wrapOnMobileWidth: '600',
        link: TYPE_SECTION_MESSAGE_MODEL.messageInfo,
        iconName: 'editItem',
        tooltipText: i18n.t('settings.users.USER_TOOLS_EDIT_TOOLTIP'),
        hideWidth: '700',
      },
    ],
    actionName: MARKETPLACE_MESSAGE,
    typeModel: MARKETPLACE_SETTINGS_MODEL.marketplace,
    tableMinWidth: 600,
    editAction: MARKETPLACE_MESSAGE_TOGGLE_ENABLED,
    dragActionName: MARKETPLACE_MESSAGE_UPDATE,
    actionLoad: MARKETPLACE_MESSAGE_GET,
    hideCellForSort: true,
    isForceUpdate: true,
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.add,
        url: MARKETPLACE_SETTINGS_MODEL.marketplaceNew,
      }),
      createControlModel({ type: MODEL_CONTROL_TYPE.sortMode }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.filter,
      }),
    ],
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS',
      }),
      createBreadcrumbModel({
        label: "settings.orderingmenu.APP_BUILDER",
      }),
    ],
    label: 'settings.marketplaceMessage.MARKETPLACE',
    sortByFunc: items => sortByPropNumber(items, 'order', false),
    mappingLambda: state => {
      return (state.marketplace.data.message || []).map(message => ({
        ...message,
        type_enum: (getMarketplaceMessageTypes().find(f => f.key === message.type) || {})['value'] || '',
      }));
    },
  });
}

export function createCustomerDeliveryPriceSectionModel({ ...args }) {
  return new SectionModel({
    columns: [
      {
        title: 'settings.personalSettings.shipmentPriceSettings.BASIS_PRICE',
        accessor: 'appbasisPrice',
        isEditable: true,
        inlineType: 'inlineOdd',
        type: CONTROL_TYPE.number,
      },
      {
        title: 'settings.personalSettings.shipmentPriceSettings.BASIS_DISTANCE_IN_METERS',
        accessor: 'appbasisDistanceInMeters',
        isEditable: true,
        type: CONTROL_TYPE.number,
      },
      {
        title: 'settings.personalSettings.shipmentPriceSettings.PRICE_PER_KM',
        accessor: 'apppricePerKm',
        isEditable: true,
        inlineType: 'inlineOdd',
        type: CONTROL_TYPE.number,
      },
      {
        title: 'settings.personalSettings.shipmentPriceSettings.MAX_DELIVERY_PRICE',
        accessor: 'appmaxDeliveryPrice',
        isEditable: true,
        type: CONTROL_TYPE.number,
      },
      {
        title: 'settings.personalSettings.shipmentPriceSettings.PRICE_CALCULATION_MODE',
        accessor: 'appmode',
        isEditable: true,
        connect: () => ({
          values: getMerchantDeliveryCostCalculationModeItems(),
        }),
        type: CONTROL_TYPE.select,
      },
    ],
    actionName: SHIPMENT_PRICE_CONFIGURATION,
    actionLoad: SHIPMENT_PRICE_CONFIGURATION_GET,
    initNewItemModel: item => item,
    typeAction: args.typeAction,
    stayAfterSave: true,
    typeModel: MARKETPLACE_SETTINGS_MODEL.customerDeliveryPrice,
    parentUrl: MARKETPLACE_SETTINGS_MODEL.customerDeliveryPrice,
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
    ],
    disabledIfEmpty: state => state?.restaurant?.data?.appShipmentPriceConfiguration,
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS' }
      ),
      createBreadcrumbModel({
        label: 'settings.orderingmenu.DELIVERY',
      }),
    ],
    label: 'settings.customerDeliveryPrice.BREADCRUMBS',
    mappingLambda: state => {
      return {
        id: 'generalsettings',
        ...state.restaurant.data.appShipmentPriceConfiguration,
      };
    },
  });
}

function createServiceCitiesSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions('search', CONTROL_TYPE.text, null, function(marketplace) {
    return getMarketplaceFilter(this.selected, marketplace);
  });

  let selectControlCenterOption = filterOptionsModel.addOptions('type', CONTROL_TYPE.multiselect, i18n.t("settings.marketplaceMessage.TYPE"), function(item) {
    return this.selected.length ? this.selected.includes(item.type) : true;
  });
  selectControlCenterOption.selected = [];
  selectControlCenterOption.mappingLambda = state => getMarketplaceMessageTypes()
    .map(type => ({
      key: type.value,
      value: type.key
    }));

  return filterOptionsModel;
}

export function createMarketplaceSettingsModel(args) {
  return new SectionModel({
    columns: [
      {
        isEditable: true,
        accessor: 'headerUrl',
        settingsAaccessor: 'headerSettings',
        type: CONTROL_TYPE.imageEdit,
      },
      {
        title: 'settings.marketplaceSettings.SCORING_ENABLED',
        accessor: 'scoringEnabled',
        isEditable: true,
        isInline: true,
        type: CONTROL_TYPE.switch,
      },
      {
        title: 'settings.marketplaceSettings.ALLOW_MULTIPLE_DISCOUNTS',
        accessor: 'allowMultipleDiscounts',
        isEditable: true,
        isInline: true,
        type: CONTROL_TYPE.switch,
      },
      {
        title: 'settings.marketplaceSettings.REQUIRE_VERIFIED_PHONE_ON_CASH',
        accessor: 'requireVerifiedPhoneOnCash',
        isEditable: true,
        isInline: true,
        type: CONTROL_TYPE.switch,
      },
      {
        title: 'settings.marketplaceSettings.REQUIRE_VERIFIED_PHONE_ON_CARD',
        accessor: 'requireVerifiedPhoneOnCard',
        isEditable: true,
        isInline: true,
        type: CONTROL_TYPE.switch,
      },
      {
        title: 'settings.marketplaceSettings.REQUIRE_VERIFIED_PHONE_ON_PROFILE',
        accessor: 'requirePhoneVerificationOnProfile',
        isEditable: true,
        isInline: true,
        type: CONTROL_TYPE.switch,
      },
      {
        title: 'settings.marketplaceSettings.TERMS_CONDITIONS_URL',
        accessor: 'termsAndConditionsUrl',
        isEditable: true,
        type: CONTROL_TYPE.text,
      },
      {
        title: 'settings.marketplaceSettings.PRIVACY_POLICY_URL',
        accessor: 'privacyPolicyUrl',
        isEditable: true,
        type: CONTROL_TYPE.text,
      },
      {
        title: 'settings.marketplaceSettings.ACCESSIBILITY_POLICY_URL',
        accessor: 'accessibilityPolicyUrl',
        isEditable: true,
        type: CONTROL_TYPE.text,
      },
      {
        title: 'settings.marketplaceSettings.ACCESSIBILITY_SITE_URL',
        accessor: 'accessibleSiteUrl',
        isEditable: true,
        type: CONTROL_TYPE.text,
      },
      {
        title: 'settings.marketplaceSettings.SUPPORT_CHAT_TYPE',
        accessor: 'supportChatType',
        connect: () => ({
          values: supportChatTypeValues(),
          defaultValue: supportChatTypeValues().find(v => v.key === SupportChatType.None),
        }),
        isEditable: true,
        type: CONTROL_TYPE.select,
      },
      {
        title: 'settings.marketplaceSettings.CALL_CENTER_PHONE',
        accessor: 'callCenterPhone',
        isEditable: true,
        type: CONTROL_TYPE.text,
      }
    ],
    actionName: MARKETPLACE_SETTINGS,
    initNewItemModel: item => item,
    typeAction: args.typeAction,
    stayAfterSave: true,
    typeModel: MARKETPLACE_SETTINGS_MODEL.marketplaceSettings,
    saveControlsConfig: {
      cancel: { title: 'basic.RESET_BUTTON', action: () => {}, isInit: true },
    },
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS',
      }),
    ],
    label: 'settings.marketplaceSettings.MENU_LABEL',
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
    ],
    mappingLambda: state => state.restaurant.data.paymentsConfiguration,
  });
}

export function createCancelReasonEditSectionModel({ ...args }) {
  return new SectionModel({
    columns: [
      {
        title: 'settings.businessCategories.CATEGORY_NAME',
        accessor: 'nameTranslations',
        isEditable: true,
        isFillContent: true,
        type: CONTROL_TYPE.languageEditor,
      },
    ],
    actionName: CANCEL_REASON,
    actionLoad: CANCEL_REASON_GET,
    initNewItemModel: item => {
      return (
          item || {
            nameTranslations: [],
          }
      );
    },
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
      }),
    ],
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS',
      }),
      createBreadcrumbModel({
        label: "settings.orderingmenu.APP_BUILDER",
      }),
    ],
    label: 'settings.cancelReason.LABEL',
    typeAction: args.typeAction,
    typeModel: args.typeAction === TYPE_ACTION.edit ? MARKETPLACE_SETTINGS_MODEL.cancelReasonEdit : MARKETPLACE_SETTINGS_MODEL.cancelReasonNew,
    parentUrl: MARKETPLACE_SETTINGS_MODEL.cancelReason,
    mappingLambda: state => {
      return state.restaurant.data.cancelReason || [];
    },
  });
}
export function createCancelReasonSectionModel() {
  return new SectionModel({
    filterOptions: createCancelReasonSectionFilter(),
    columns: [
      {
        title: 'settings.cancelReason.REASON',
        accessor: 'name'
      },
      {
        title: 'basic.EDIT_BUTTON',
        width: "150px",
        centered: true,
        type: CONTROL_TYPE.link,
        link: MARKETPLACE_SETTINGS_MODEL.cancelReasonEdit,
        iconName: 'editItem',
        tooltipText: i18n.t('settings.users.USER_TOOLS_EDIT_TOOLTIP'),
      },
    ],
    actionName: CANCEL_REASON,
    actionLoad: CANCEL_REASON_GET,
    tableMinWidth: 300,
    typeModel: MARKETPLACE_SETTINGS_MODEL.cancelReason,
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.add,
        url: MARKETPLACE_SETTINGS_MODEL.cancelReasonNew,
      }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
    ],
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS',
      }),
      createBreadcrumbModel({
        label: "settings.orderingmenu.APP_BUILDER",
      }),
    ],
    label: 'settings.cancelReason.LABEL',
    sortByFunc: function(items) {
      return sortByProp(items);
    },
    mappingLambda: state => {
      const data = state.restaurant.data.cancelReason || [];
      return data.filter(reason => !reason.isDeleted).map(reason => {
        const name = reason?.nameTranslations === null ? '' : reason?.nameTranslations[i18n.language];
        const secondName = Object.values(reason?.nameTranslations || [])[0];
        return {
          name: name || secondName || '',
          ...reason,
        }
      })
    }
  });
}

function createCancelReasonSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions('search', CONTROL_TYPE.text, null, function(businessCategory) {
    return getBusinesMenuCategoriesFilter(this.selected, businessCategory);
  });

  return filterOptionsModel;
}

export function createGreetingTemplatesEditSectionModel({ ...args }) {
  return new SectionModel({
    columns: [
      {
        title: 'settings.greetingTemplates.TEMPLATE',
        accessor: 'textTranslations',
        isEditable: true,
        isTextArea: true,
        isFullWidth: true,
        type: CONTROL_TYPE.languageEditor,
      },
      {
        title: 'settings.greetingTemplates.ENABLED',
        accessor: 'enabled',
        isEditable: true,
        isInline: true,
        type: CONTROL_TYPE.switch,
      },
    ],
    actionName: GREETING_TEMPLATE,
    actionLoad: GREETING_TEMPLATE_GET,
    initNewItemModel: item => getInitModel(MODEL_TYPE.greetingTemplateModel, item),
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
      }),
    ],
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS',
      }),
      createBreadcrumbModel({
        label: "settings.orderingmenu.APP_BUILDER",
      }),
    ],
    label: 'settings.greetingTemplates.LABEL',
    typeAction: args.typeAction,
    typeModel: args.typeAction === TYPE_ACTION.edit ? MARKETPLACE_SETTINGS_MODEL.greetingTemplatesEdit : MARKETPLACE_SETTINGS_MODEL.greetingTemplatesNew,
    parentUrl: MARKETPLACE_SETTINGS_MODEL.greetingTemplates,
    mappingLambda: state => {
      return state.restaurant.data.greetingTemplate || [];
    },
  });
}

export function createGreetingTemplatesSectionModel() {
  return new SectionModel({
    filterOptions: createGreetingTemplatesSectionFilter(),
    columns: [
      {
        title: 'settings.greetingTemplates.TEMPLATE',
        accessor: 'name'
      },
      {
        title: 'settings.greetingTemplates.ENABLED',
        accessor: 'enabled',
        isEditable: true,
        type: CONTROL_TYPE.switch,
        width: '200px',
      },
      {
        title: 'basic.EDIT_BUTTON',
        width: "150px",
        centered: true,
        type: CONTROL_TYPE.link,
        link: MARKETPLACE_SETTINGS_MODEL.greetingTemplatesEdit,
        iconName: 'editItem',
        tooltipText: i18n.t('settings.users.USER_TOOLS_EDIT_TOOLTIP'),
      },
    ],
    actionName: GREETING_TEMPLATE,
    actionLoad: GREETING_TEMPLATE_GET,
    tableMinWidth: 300,
    typeModel: MARKETPLACE_SETTINGS_MODEL.greetingTemplates,
    editAction: GREETING_TEMPLATE_TOGGLE_ENABLED,
    isForceUpdate: true,
    dragActionName: GREETING_TEMPLATE_UPDATE,
    dragSortPropName: 'position',
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.add,
        url: MARKETPLACE_SETTINGS_MODEL.greetingTemplatesNew,
      }),
      createControlModel({ type: MODEL_CONTROL_TYPE.sortMode }),
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
    ],
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS',
      }),
      createBreadcrumbModel({
        label: "settings.orderingmenu.APP_BUILDER",
      }),
    ],
    label: 'settings.greetingTemplates.LABEL',
    sortByFunc: function(items) {
      return sortByProp(items, 'position');
    },
    mappingLambda: state => {
      const data = state.restaurant.data.greetingTemplate || [];
      return data.filter(template => !template.isDeleted).map(template => {
        const text = (template.textTranslations || {})[i18n.language];
        const secondText = Object.values(template.textTranslations || {})[0];
        return {
          name: text || secondText || '',
          ...template,
        }
      })
    }
  });
}

function createGreetingTemplatesSectionFilter() {
  let filterOptionsModel = new FilterOptionsModel();

  filterOptionsModel.addOptions('search', CONTROL_TYPE.text, null, function(greetingTemplate) {
    return getBusinesMenuCategoriesFilter(this.selected, greetingTemplate);
  });

  return filterOptionsModel;
}

export function createScheduleSettingsSectionModel({...args}) {
  return new SectionModel({
    columns: [
      {
        title: 'settings.scheduleSettings.OFFSET_IN_MINUTES',
        accessor: 'offsetInMinutes',
        // measure: i18n.t('settings.settings.numericalSettings.TIME_MEASURE'),
        isEditable: true,
        type: CONTROL_TYPE.number,
      },
      {
        title: 'settings.scheduleSettings.LATEST_SLOT_IN_DAYS',
        accessor: 'latestSlotInDays',
        // measure: i18n.t('settings.settings.numericalSettings.TIME_MEASURE'),
        isEditable: true,
        type: CONTROL_TYPE.number,
      },
      {
        id: 'group1',
        headerTitle: 'settings.scheduleSettings.MINUTE_SLOTS',
        columns: [
          {
            title: 'settings.scheduleSettings.MINUTE_SLOTS-0',
            accessor: 'minuteSlots-0',
            isEditable: true,
            type: CONTROL_TYPE.checkbox,
          },
          {
            title: 'settings.scheduleSettings.MINUTE_SLOTS-15',
            accessor: 'minuteSlots-15',
            isEditable: true,
            type: CONTROL_TYPE.checkbox,
          },
          {
            title: 'settings.scheduleSettings.MINUTE_SLOTS-30',
            accessor: 'minuteSlots-30',
            isEditable: true,
            type: CONTROL_TYPE.checkbox,
          },
          {
            title: 'settings.scheduleSettings.MINUTE_SLOTS-45',
            accessor: 'minuteSlots-45',
            isEditable: true,
            type: CONTROL_TYPE.checkbox,
          },
        ],
        isEditable: true,
        resetMargin: true,
        type: CONTROL_TYPE.group,
      },
    ],
    actionName: SCHEDULE_SETTINGS,
    actionLoad: SCHEDULE_SETTINGS_GET,
    initNewItemModel: item => item,
    typeAction: args.typeAction,
    stayAfterSave: true,
    typeModel: MARKETPLACE_SETTINGS_MODEL.scheduleSettings,
    controls: [
      createControlModel({
        type: MODEL_CONTROL_TYPE.back,
        isShow: isMobileWidth,
      }),
    ],
    breadcrumbs: [
      createBreadcrumbModel({
        label: 'header.menu.MARKETPLACE_SETTINGS' }
      ),
      createBreadcrumbModel({
        label: 'settings.orderingmenu.APP_BUILDER',
      }),
    ],
    label: 'settings.scheduleSettings.LABEL',
    mappingLambda: state => {
      return {
        id: 'scheduleSettings',
        ...state.restaurant.data.scheduleSettings,
      };
    },
  });
}